import { EmailUtils } from '../email-utils';

export class EmailValidator {
    private static oneAtAndSomethingBeforeAndAfter = (text: string) => /.+@.+\.+.+/.test(text);
    private static twoDotsInRow = (text: string) => /\.\./.test(text);
    private static twoAtInRow = (text: string) => /@@/.test(text);
    private static dotAt = (text: string) => /\.@/.test(text);
    private static atDot = (text: string) => /@\./.test(text);

    public static isValid(email: string): boolean {
        const isValid = !email || this.oneAtAndSomethingBeforeAndAfter(email) && !this.twoDotsInRow(email) && !this.twoAtInRow(email)
            && !this.dotAt(email) && !this.atDot(email);

        return isValid;
    }

    public static isValidEmails(email: string | null): boolean {
        if (!email) return true;
        const emails = EmailUtils.extractEmails(email);

        return this.getInvalidEmailsFromArray(emails).length <= 0;
    }

    public static getInvalidEmailsFromArray(value: string[]) {
        return value.filter((val: string) => !this.isValid(val));
    }
}
